import { useBotConfiguration } from './useBotConfiguration'

export function useLoadedBotPreviewUrl() {
  return useBotConfiguration()?.previewUrl
}
